import { LOCALE } from '~/translations/translation.types';

const baseURL =
  process.env.BASE_URL + '/web/public/content-store/content/translations-tree/translations';

class TranslationClient {
  constructor(url) {
    this.url = url;
  }

  getTranslations = async (locale = LOCALE.RU) => {
    const response = await fetch(this.url + `?filters=${locale}`);
    const result = await response.json();
    const translations = result[locale] || {};

    if (Object.keys(translations).length) {
      return translations;
    } else {
      return {};
    }
  };
}

export const TranslationService = new TranslationClient(baseURL);
